import React from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import styled from 'styled-components'
import ReactGA from 'react-ga'
import './App.css'
import Home from './pages/home'
import RevenueByDepartment from './components/revenue/revenue-by-department'
import DataLayout from './components/data-layout'
import RevenueByLineNo from './components/revenue/revenue-by-line-no'
import RevenueByObjectCode from './components/revenue/revenue-by-object-code'
import SpendingByDepartment from './components/department/spending-by-department'
import SpendingByDeptNo from './components/department/spending-by-dept-no'
import SpendingByCharCode from './components/department/spending-by-char-code'
import SpendingByObjectCode from './components/department/spending-by-obj-code'
import SpendingByVendor from './components/vendor/spending-by-vendor'
import SpendingByVendorNo from './components/vendor/spending-by-vendor-no'
import Search from './components/search'

ReactGA.initialize('UA-76077918-1')

const Container = styled.div`
  padding: 10px 0;
  max-width: 1000px;
  margin: 0 auto;
  color: rgb(35, 31, 32);
  font-size: 14px;
  font-family: 'Open Sans', sans-serif;
  line-height: 1.56em;
`

const Temp = () => (
  <DataLayout>
    <div>temp</div>
  </DataLayout>
)

function App() {
  return (
    <Container>
      <Router>
        <Route path="/" exact component={Home} />
        <Route path="/vendor/:year" exact component={SpendingByVendor} />
        <Route
          path="/vendor/:year/:vendorNo"
          exact
          component={SpendingByVendorNo}
        />
        <Route
          path="/department/:year"
          exact
          component={SpendingByDepartment}
        />
        <Route
          path="/department/:year/:deptNo"
          exact
          component={SpendingByDeptNo}
        />
        <Route
          path="/department/:year/:deptNo/:charCode"
          exact
          component={SpendingByCharCode}
        />
        <Route
          path="/department/:year/:deptNo/:charCode/:objCode"
          exact
          component={SpendingByObjectCode}
        />
        <Route path="/revenue/:year" exact component={RevenueByDepartment} />
        <Route
          path="/revenue/:year/:lineNo"
          exact
          component={RevenueByLineNo}
        />
        <Route
          path="/revenue/:year/:lineNo/:objCode"
          exact
          component={RevenueByObjectCode}
        />
        <Route path="/find/:searchText" exact component={Search} />
      </Router>
    </Container>
  )
}

export default App
